import { createAction } from 'redux-actions'

const ns = 'register-user/'

export const registerUser = createAction(`${ns}REGISTER_USER`)
export const registerUserSuccess = createAction(`${ns}REGISTER_USER_SUCCESS`)
export const registerUserFail = createAction(`${ns}REGISTER_USER_FAIL`)

export const registerAppleHealth = createAction(`${ns}REGISTER_APPLE_HEALTH`)
export const registerWithoutIntegration = createAction(`${ns}REGISTER_WITHOUT_INTEGRATION`)

export const setOnboardingStatusToActivityData = createAction(`${ns}SET_ONBOARDING_STATUS_TO_ACTIVITY_DATA`)
export const setOnboardingStatusToIntegration = createAction(`${ns}SET_ONBOARDING_STATUS_TO_INTEGRATION`)

export const updateProfileData = createAction(`${ns}UPDATE_PROFILE_DATA`)
export const updateActivityData = createAction(`${ns}UPDATE_ACTIVITY_DATA`)
